import Vue from 'vue'
import Router from 'vue-router'
import Quote from './view/quote'
import Home from './view/home'
import Dashboard from './view/dashboard'
import WhiteGlovePickup from './view/white-glove/pickup'
import QuoteReview from './view/white-glove/review'
import WhiteGloveManifest from './view/white-glove/manifest'
import Clients from './view/clients'
import CommissionPage from './view/commission-page'
import store from '@/state/store'
import { logoutUrl } from '@/services/storefront'
import Print from './view/print-manifest'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: 'Home | Please log in'
    }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true,
      title: 'Dashboard | Manage Your Clients'
    }
  },
  {
    path: '/quotes/pickup/:id',
    name: 'quote-pickup',
    component: WhiteGlovePickup,
    meta: {
      requiresAuth: true,
      title: 'White Glove'
    }
  },
  {
    path: '/quotes/review/:id',
    name: 'quote-review',
    component: QuoteReview,
    meta: {
      requiresAuth: true,
      title: 'Review Quotes'
    }
  },
  {
    path: '/quotes/manifest/:shipmentId',
    name: 'quote-manifest',
    component: WhiteGloveManifest,
    meta: {
      requiresAuth: true,
      title: 'White Glove'
    }
  },
  {
    path: '/clients',
    name: 'clients',
    component: Clients,
    meta: {
      requiresAuth: true,
      title: 'Clients | All Clients'
    }
  },
  {
    path: '/quote/:id',
    name: 'quotes',
    component: Quote,
    meta: {
      title: 'Quote Share'
    }
  },
  {
    path: '/commission/:id',
    name: 'commission',
    meta: {
      requiresAuth: true,
      title: 'Commissions'
    },
    component: CommissionPage
  },
  {
    path: '/quotes/:id',
    name: 'quote-offer',
    component: Quote,
    meta: {
      title: 'Approve White Glove Offers'
    }
  },
  {
    path: '/quotes/:shipmentId/print',
    name: 'quote-print',
    component: Print,
    meta: {
      title: 'Print White Glove Manifest'
    }
  },
  {
    path: '/logout',
    name: 'logout',
    beforeEnter (routeTo, routeFrom, next) {
      store.commit('logoutUser')
      window.location.href = logoutUrl()
    },
    meta: {
      title: 'Logout'
    }
  }
]

const router = new Router({
  mode: 'history',
  routes: routes
})

// Verified once per page load (module-scoped, deliberately not persisted):
// null = not checked yet, true/false = result of the /api/account check.
let isVerifiedStylist = null

router.beforeEach(async (to, from, next) => {
  await window.isClerkLoaded
  const clerkUser = window.Clerk && window.Clerk.user
  if (clerkUser && isVerifiedStylist === null) {
    isVerifiedStylist = await store.dispatch('verifyStylist')
    if (isVerifiedStylist && !store.state.stylist) {
      await store.dispatch('getStylist')
    }
  }
  const authorized = !!clerkUser && isVerifiedStylist === true
  if (!authorized) {
    if (to.name !== 'home') {
      next({ name: 'home' })
      return
    }
  } else if (to.name === 'home') {
    next({ name: 'dashboard' })
    return
  }
  document.title = 'Fashionphile Stylist Program | ' + to.meta.title
  next()
})
router.afterEach((route) => {
  Vue.nextTick(function () {
    const elementId = route.query.go
    if (!elementId) {
      return
    }
    const element = document.getElementById(elementId)
    if (!element) {
      return
    }

    setTimeout(function () {
      const top = element.offsetTop - 150
      window.scrollTo({ top: top, behavior: 'smooth' })
    }, 2000)
  })
})

export default router
